import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SkipperHaftpflichtFormModel } from '../models/forms/skipper-haftpflicht-form.model';
import { CallidusSkipperVersicherungssummeKunde } from '@backend/models';
import { DateValidator } from '@shared/validators/date.validator';

export function createSkipperHaftpflichtForm(): FormGroup<SkipperHaftpflichtFormModel> {
  return new FormGroup<SkipperHaftpflichtFormModel>({
    callidusSkipperVersicherungssummeKunde: new FormControl<CallidusSkipperVersicherungssummeKunde>(CallidusSkipperVersicherungssummeKunde.Versicherungssumme5Mio, Validators.required),

    hasBeantragteRisikenGekuendigtOderAbgelehnt: new FormControl<boolean | null>(null, Validators.required),
    versicherungsgesellschaftGekuendigtOderAbgelehnt: new FormControl<string | null>(null),
    versicherungsgesellschaftYearGekuendigtOderAbgelehnt: new FormControl<number | null>(null, [DateValidator.maxDate(new Date())]),
    versicherungsgesellschaftPolicyNumberGekuendigtOderAbgelehnt: new FormControl<string | null>(null),
    versicherungsgesellschaftSparteGekuendigtOderAbgelehnt: new FormControl<string | null>(null),
    versicherungsgesellschaftGrundGekuendigtOderAbgelehnt: new FormControl<string | null>(null),

    hasSchaedenBereitsErlitten: new FormControl<boolean | null>(null, Validators.required),
    hasRisikenBereitsVersichert: new FormControl<boolean | null>(null, Validators.required)
  });
}
